export default __webpack_public_path__ + "static/media/bur.8f2211e2.svg";